import { render, staticRenderFns } from "./BreakTimeBlock.vue?vue&type=template&id=0984f9b4"
import script from "./BreakTimeBlock.vue?vue&type=script&lang=js"
export * from "./BreakTimeBlock.vue?vue&type=script&lang=js"
import style0 from "./BreakTimeBlock.vue?vue&type=style&index=0&id=0984f9b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports